/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Associateduserswillbe3Inputs */

const en_settings_associateduserswillbe3 = /** @type {(inputs: Settings_Associateduserswillbe3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Associated users will be informed of added emails`)
};

/**
* | output |
* | --- |
* | "Associated users will be informed of added emails" |
*
* @param {Settings_Associateduserswillbe3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_associateduserswillbe3 = /** @type {((inputs?: Settings_Associateduserswillbe3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Associateduserswillbe3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_associateduserswillbe3(inputs)
});
export { settings_associateduserswillbe3 as "settings_associatedUsersWillBe" }